// client/src/components/ProductCarousel.js
import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import ProductCard from './ProductCard';

const ProductCarousel = ({ title, products }) => {
  if (!Array.isArray(products) || products.length === 0) {
    return null;
  }

  return (
    <Container maxWidth={false} disableGutters component="section" sx={{ mb: 5 }}>
      <Typography variant="h5" component="h2" sx={{ mb: 2.5 }}>{title}</Typography>
      {/* As many columns as fit the full width, so rows stay packed edge to edge. */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
          gap: 2,
        }}
      >
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </Box>
    </Container>
  );
};

export default ProductCarousel;
